import dayjs from "dayjs";

export const OLD_ACCOUNT_THRESHOLD_YEARS = 2;

export const isAccountOlderThanThreshold = (
  dateOpenReal?: string | null,
  threshold: number = OLD_ACCOUNT_THRESHOLD_YEARS,
): boolean => {
  if (!dateOpenReal) return false;

  const openedAt = dayjs(dateOpenReal);
  if (!openedAt.isValid()) return false;

  return dayjs().diff(openedAt, "year") >= threshold;
};
